import immutableStore from 'alt-utils/lib/ImmutableUtil';
import alt from 'components/Dispatcher';
import CoachingStatsActions from 'actions/coaching/CoachingStatsActions';
import {Record} from 'immutable';

@immutableStore
class CoachingStatsStore {
  constructor() {
    this.state = Record({
      coachingStats: null,
      coachingStatsLoading: false,
      coachingStatsError: false,
    })();

    this.bindActions(CoachingStatsActions);
  }

  coachingStatsSuccess(stats) {
    this.setState({
      ...this.state,
      coachingStats: stats,
      coachingStatsLoading: false,
    });
  }

  coachingStatsError() {
    this.setState({
      ...this.state,
      coachingStats: null,
      coachingStatsError: true,
    });
  }
}

export default alt.createStore(CoachingStatsStore, 'CoachingStatsStore');
